import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import Swal from "sweetalert2";
import "./index.css";

const CadUploadEstrutura = () => {
  const navigate = useNavigate();
  const { IDProcesso, IDDiretorioPai, NomeBucketAws } = useParams();
  const [clienteLogado, setclienteLogado] = useState();
  const { objClienteAberto } = usePentagovContext();
  const { IDOperador, nome, operador } = useOperador();
  const { authReady } = useAuthContext();

  const [arquivos, setArquivos] = useState([]);
  const [progresso, setProgresso] = useState(0);
  const [total, setTotal] = useState(0);
  const [concluidos, setConcluidos] = useState(0);
  const [falhas, setFalhas] = useState(0);
  const [logErros, setLogErros] = useState([]);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (operador && authReady) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setclienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  async function inicializaTela() {}

  const handleSelecionarPasta = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    setArquivos(files);
    setTotal(files.length);
    setConcluidos(0);
    setFalhas(0);
    setProgresso(0);
    setLogErros([]);
  };

  const baixarLog = () => {
    const blob = new Blob([JSON.stringify(logErros, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "log_erros_migracao.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  const criarPastasSeNecessario = async (path, mapaPastas) => {
    const partes = path.split("/").filter(Boolean);
    let idPai = IDDiretorioPai;
    let chaveAcumulada = idPai ? `root-${idPai}` : "root";

    for (let i = 0; i < partes.length; i++) {
      const nomeParte = partes[i];
      chaveAcumulada += `/${nomeParte}`;

      if (mapaPastas.has(chaveAcumulada)) {
        idPai = mapaPastas.get(chaveAcumulada);
        continue;
      }

      try {
        const res = await api.post("/diretorio", {
          IDProcesso,
          IDCriador: IDOperador,
          descricao: nomeParte,
          descricaoExibicao: nomeParte,
          IDPai: idPai,
          IDFilho: null,
          nomeBucketAws: NomeBucketAws,
          tipo: "1",
          situacao: 1,
        });

        const novoId = res.data?.IDDiretorio;
        mapaPastas.set(chaveAcumulada, novoId);
        idPai = novoId;
      } catch (err) {
        setFalhas((valorAtual) => valorAtual + 1);
        setLogErros((logAtual) => [...logAtual, { tipo: "pasta", nome: nomeParte, erro: err.message }]);
        throw err;
      }
    }

    return idPai;
  };

  const iniciarUpload = async () => {
    if (!IDProcesso?.trim()) {
      Swal.fire("Aviso", "ID do Processo nao informado", "warning");
      return;
    }
    if (!arquivos.length) {
      Swal.fire("Aviso", "Selecione uma pasta antes de iniciar.", "warning");
      return;
    }

    setEnviando(true);

    const mapaPastas = new Map();
    mapaPastas.set("root", IDDiretorioPai || null);

    for (let i = 0; i < arquivos.length; i++) {
      const file = arquivos[i];
      const relativePath = file.webkitRelativePath;
      const pastaPath = relativePath.substring(0, relativePath.lastIndexOf("/"));

      try {
        const idDiretorio = await criarPastasSeNecessario(pastaPath, mapaPastas);

        const formData = new FormData();
        formData.append("uploadId", crypto.randomUUID());
        formData.append("IDDiretorio", String(idDiretorio));
        formData.append("tipoPermissao", "99");
        formData.append("bucketName", NomeBucketAws);
        formData.append(
          "arquivosInfo",
          JSON.stringify([
            {
              key: crypto.randomUUID(),
              originalName: file.name,
              size: file.size,
            },
          ])
        );
        formData.append("arquivos", file, file.name);
        formData.append("IDCriador", IDOperador);

        await api.post("/upload-direto", formData);
        setConcluidos((valorAtual) => valorAtual + 1);
      } catch (err) {
        const caminhoRelativo = file.webkitRelativePath || file.name;
        setFalhas((valorAtual) => valorAtual + 1);
        setLogErros((logAtual) => [
          ...logAtual,
          {
            tipo: "arquivo",
            nome: caminhoRelativo,
            erro: err?.response?.data?.message || err?.message || "Erro desconhecido",
          },
        ]);
      }
      setProgresso(Math.round(((i + 1) / total) * 100));
    }

    setEnviando(false);
    window.dispatchEvent(new Event("assinatura:notifications-refresh"));
    Swal.fire("Finalizado", "Processo concluido!", "success");
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <div className="page-shell upload-estrutura-page">
          <MenuSuperior userId={String(IDOperador).padStart(6, "0")} userName={nome} cliente={clienteLogado} />

          <section className="upload-estrutura-card">
            <h3>Migrar Estruturas de Pasta para PentaGOV</h3>
            <p>
              Selecione uma pasta local para enviar toda a estrutura de diretorios e arquivos para o processo atual.
            </p>

            <div className="upload-estrutura-file-row">
              <input
                className="upload-estrutura-file-input"
                type="file"
                {...{ webkitdirectory: "", directory: "", multiple: true }}
                onChange={handleSelecionarPasta}
              />
            </div>

            {arquivos.length > 0 && (
              <div className="upload-estrutura-stats">
                <div className="upload-estrutura-grid">
                  <div>
                    <strong>{total}</strong>
                    <span>Total de arquivos</span>
                  </div>
                  <div>
                    <strong>{concluidos}</strong>
                    <span>Concluidos</span>
                  </div>
                  <div>
                    <strong>{falhas}</strong>
                    <span>Falhas</span>
                  </div>
                  <div>
                    <strong>{total - (concluidos + falhas)}</strong>
                    <span>Restantes</span>
                  </div>
                </div>

                <div className="upload-estrutura-progress">
                  <div
                    className="upload-estrutura-progress__bar"
                    style={{ width: `${progresso}%` }}
                  ></div>
                </div>
                <div className="upload-estrutura-progress__label">{progresso}% concluido</div>
              </div>
            )}

            <div className="upload-estrutura-actions">
              <button className="upload-estrutura-btn" onClick={iniciarUpload} disabled={enviando}>
                {enviando ? "Enviando..." : "Iniciar Migracao"}
              </button>

              {logErros.length > 0 && (
                <button className="upload-estrutura-btn upload-estrutura-btn--secondary" onClick={baixarLog}>
                  Baixar Log de Erros
                </button>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CadUploadEstrutura;
